// src/services/apiService.js

const API_BASE_URL = 'https://apps.genus.in/GenOpsAPI/api';
//const API_BASE_URL = 'http://localhost:5134/api';

const COMPANY_NAME = 'Genus';

// ✅ Cookie is sent automatically by the browser — no Authorization header needed
// credentials: 'include' tells the browser to send the HTTP-only cookie
const defaultFetchOptions = {
  credentials: 'include',
  headers: {
    'accept': '*/*',
    'Content-Type': 'application/json'
  }
};

const apiService = {

  login: async (userid, password) => {
    try {
      const response = await fetch(`${API_BASE_URL}/Auth/login`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'accept': '*/*', 'Content-Type': 'application/json' },
        body: JSON.stringify({ userid, password, company: COMPANY_NAME })
      });

      if (!response.ok) {
        if (response.status === 401) throw new Error('Invalid User or Password');
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.result || !data.result.employeeCode) {
        return { success: false, message: data.message || 'Invalid User or Password.' };
      }

      // ✅ Token is in the HTTP-only cookie — no manual storage needed
      return { success: true, data: data.result };
    } catch (error) {
      console.error('Login API Error:', error);
      return { success: false, message: error.message || 'An error occurred during login' };
    }
  },

  verifyToken: async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/Auth/verify`, {
          method: 'GET',
          credentials: 'include'
        });

        if (!response.ok) return null;  // ✅ null = not authenticated

        const data = await response.json();
        return data;   // ✅ returns { valid, employeeCode, employeeName, location }
      } catch {
        return null;
      }
    },

  // ✅ Clears the HTTP-only cookie server-side
  logout: async () => {
    try {
      await fetch(`${API_BASE_URL}/Auth/logout`, {
        method: 'POST',
        credentials: 'include'
      });
    } catch (error) {
      console.error('Logout error:', error);
    }
  },

  generateLineSummary: async ({ serverId, area, shift, productionDate, employeeId }) => {
    try {
      const empId = parseInt(employeeId);
      const url = `${API_BASE_URL}/LineSummary/generate?serverId=${serverId}&area=${area}&shift=${shift}&productionDate=${productionDate}&employeeId=${empId}`;

      const response = await fetch(url, {
        method: 'POST',
        ...defaultFetchOptions,
        body: ''
      });

      if (!response.ok) throw new Error(`Failed to generate summary: ${response.status}`);

      const data = await response.json();
      return {
        success: true,
        message: data.message || 'Summary generated successfully',
        linesProcessed: data.linesProcessed || 0,
        date: data.date,
        shift: data.shift
      };
    } catch (error) {
      console.error('Generate Summary API Error:', error);
      return { success: false, message: error.message || 'An error occurred while generating summary' };
    }
  },

  getLineSummary: async ({ serverId, area, shift, productionDate }) => {
    try {
      const url = `${API_BASE_URL}/LineSummary?serverId=${serverId}&area=${encodeURIComponent(area)}&shift=${shift}&productionDate=${productionDate}`;

      const response = await fetch(url, { method: 'GET', ...defaultFetchOptions });

      if (!response.ok) throw new Error(`Failed to fetch summary: ${response.status}`);

      const data = await response.json();

      let summaryData = [];
      if (Array.isArray(data))                            summaryData = data;
      else if (data.result && Array.isArray(data.result)) summaryData = data.result;
      else if (data.data   && Array.isArray(data.data))   summaryData = data.data;

      return {
        success: true,
        data: summaryData,
        message: summaryData.length > 0 ? 'Data loaded successfully' : 'No data found'
      };
    } catch (error) {
      console.error('Get Summary API Error:', error);
      return { success: false, data: [], message: error.message || 'An error occurred while fetching summary' };
    }
  },

  getLoginHistory: async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      if (filters.startDate) params.append('startDate', filters.startDate);
      if (filters.endDate)   params.append('endDate',   filters.endDate);

      const response = await fetch(`${API_BASE_URL}/LoginHistory?${params.toString()}`,
        { method: 'GET', ...defaultFetchOptions });

      const data = await response.json();
      return { success: true, data };
    } catch (error) {
      return { success: false, data: [], message: error.message };
    }
  },

  getTargetDetails: async ({ serverId, shift, area, projCode, lineNo, startDate, endDate }) => {
    try {
      const url = `${API_BASE_URL}/EntryFrom/savedproductiondetails/range?serverId=${serverId}&shift=${shift}&area=${area}&projCode=${encodeURIComponent(projCode)}&lineNo=${lineNo}&startDate=${startDate}&endDate=${endDate}`;

      const response = await fetch(url, { method: 'GET', ...defaultFetchOptions });

      if (!response.ok) return { success: false, data: null };

      const data = await response.json();
      return { success: true, data: Array.isArray(data) && data.length > 0 ? data[0] : null };
    } catch (error) {
      console.error('Get Target Details API Error:', error);
      return { success: false, data: null };
    }
  }
};

export { apiService };
export default apiService;



//--------------------------------------
// // src/services/apiService.js

// const API_BASE_URL = 'http://localhost:5134/api';
// const COMPANY_NAME = 'Genus';

// // ✅ Helper — attaches JWT to every request automatically
// const getAuthHeaders = () => ({
//   'accept': '*/*',
//   'Content-Type': 'application/json',
//   'Authorization': `Bearer ${sessionStorage.getItem('JwtToken') || ''}`
// });

// const apiService = {

//   // ✅ Login — now also returns the JWT token from backend
//   login: async (userid, password) => {
//     try {
//       const url = `${API_BASE_URL}/Auth/login?userid=${encodeURIComponent(userid)}&password=${encodeURIComponent(password)}&company=${encodeURIComponent(COMPANY_NAME)}`;

//       const response = await fetch(url, {
//         method: 'POST',
//         headers: {
//           'accept': '*/*',
//           'Content-Type': 'application/json'
//         },
//         body: ''
//       });

//       if (!response.ok) {
//         if (response.status === 401) throw new Error('Invalid User or Password');
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const data = await response.json();

//       if (!data.result || !data.result.employeeCode) {
//         return { success: false, message: data.message || 'Invalid User or Password.' };
//       }

//       return {
//         success: true,
//         data:  data.result,
//         token: data.token    // ✅ real JWT from backend
//       };
//     } catch (error) {
//       console.error('Login API Error:', error);
//       return { success: false, message: error.message || 'An error occurred during login' };
//     }
//   },

//   // ✅ NEW — verify token with server on every app load
//   verifyToken: async () => {
//     try {
//       const response = await fetch(`${API_BASE_URL}/Auth/verify`, {
//         method: 'GET',
//         headers: getAuthHeaders()
//       });
//       return response.ok;
//     } catch {
//       return false;
//     }
//   },

//   // ✅ JWT added to all methods below
//   generateLineSummary: async ({ serverId, area, shift, productionDate, employeeId }) => {
//     try {
//       const empId = parseInt(employeeId);
//       const url = `${API_BASE_URL}/LineSummary/generate?serverId=${serverId}&area=${area}&shift=${shift}&productionDate=${productionDate}&employeeId=${empId}`;

//       const response = await fetch(url, {
//         method: 'POST',
//         headers: getAuthHeaders(),
//         body: ''
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(`Failed to generate summary: ${response.status}`);
//       }

//       const data = await response.json();

//       return {
//         success: true,
//         message: data.message || 'Summary generated successfully',
//         linesProcessed: data.linesProcessed || 0,
//         date:  data.date,
//         shift: data.shift
//       };
//     } catch (error) {
//       console.error('Generate Summary API Error:', error);
//       return { success: false, message: error.message || 'An error occurred while generating summary' };
//     }
//   },

//   getLineSummary: async ({ serverId, area, shift, productionDate }) => {
//     try {
//       const url = `${API_BASE_URL}/LineSummary?serverId=${serverId}&area=${encodeURIComponent(area)}&shift=${shift}&productionDate=${productionDate}`;

//       const response = await fetch(url, {
//         method: 'GET',
//         headers: getAuthHeaders()
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(`Failed to fetch summary: ${response.status}`);
//       }

//       const data = await response.json();

//       let summaryData = [];
//       if (Array.isArray(data))                         summaryData = data;
//       else if (data.result && Array.isArray(data.result)) summaryData = data.result;
//       else if (data.data   && Array.isArray(data.data))   summaryData = data.data;

//       return {
//         success: true,
//         data:    summaryData,
//         message: summaryData.length > 0 ? 'Data loaded successfully' : 'No data found'
//       };
//     } catch (error) {
//       console.error('Get Summary API Error:', error);
//       return { success: false, data: [], message: error.message || 'An error occurred while fetching summary' };
//     }
//   },

//   getLoginHistory: async (filters = {}) => {
//     try {
//       const params = new URLSearchParams();
//       if (filters.startDate) params.append('startDate', filters.startDate);
//       if (filters.endDate)   params.append('endDate',   filters.endDate);

//       const url = `${API_BASE_URL}/LoginHistory?${params.toString()}`;

//       const response = await fetch(url, {
//         method: 'GET',
//         headers: getAuthHeaders()
//       });

//       const data = await response.json();
//       return { success: true, data };
//     } catch (error) {
//       return { success: false, data: [], message: error.message };
//     }
//   },

//   getTargetDetails: async ({ serverId, shift, area, projCode, lineNo, startDate, endDate }) => {
//     try {
//       const url = `${API_BASE_URL}/EntryFrom/savedproductiondetails/range?serverId=${serverId}&shift=${shift}&area=${area}&projCode=${encodeURIComponent(projCode)}&lineNo=${lineNo}&startDate=${startDate}&endDate=${endDate}`;

//       const response = await fetch(url, {
//         method: 'GET',
//         headers: getAuthHeaders()
//       });

//       if (!response.ok) {
//         return { success: false, data: null };
//       }

//       const data = await response.json();
//       const targetData = Array.isArray(data) && data.length > 0 ? data[0] : null;

//       return { success: true, data: targetData };
//     } catch (error) {
//       console.error('Get Target Details API Error:', error);
//       return { success: false, data: null };
//     }
//   }
// };

// export { apiService };
// export default apiService;


// // src/services/apiService.js

// //const API_BASE_URL = 'https://apps.genus.in/GenOpsAPI/api';
// const API_BASE_URL = 'http://localhost:5134/api';
// const COMPANY_NAME = 'Genus';

// const apiService = {
//   /**
//    * Login user with userid and password
//    */
//   login: async (userid, password) => {
//     try {
//       const url = `${API_BASE_URL}/Auth/login?userid=${encodeURIComponent(userid)}&password=${encodeURIComponent(password)}&company=${encodeURIComponent(COMPANY_NAME)}`;
      
//       const response = await fetch(url, {
//         method: 'POST',
//         headers: {
//           'accept': '*/*',
//           'Content-Type': 'application/json'
//         },
//         body: ''
//       });

//       if (!response.ok) {
//         if (response.status === 401) {
//           throw new Error('Invalid User or Password');
//         }
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }

//       const data = await response.json();

//       // Validate that the API returned a real authenticated user
//       if (!data.result || !data.result.employeeCode) {
//         return {
//           success: false,
//           message: data.message || 'Invalid User or Password.'
//         };
//       }

//       return {
//         success: true,
//         data: data.result
//       };
//     } catch (error) {
//       console.error('Login API Error:', error);
//       return {
//         success: false,
//         message: error.message || 'An error occurred during login'
//       };
//     }
//   },

//   /**
//    * Generate Daily Line Summary
//    * POST /api/LineSummary/generate
//    * Parameters: serverId (int), area (string), shift (string), productionDate (string), employeeId (int)
//    */
//   generateLineSummary: async ({ serverId, area, shift, productionDate, employeeId }) => {
//     try {
//       // Convert employeeId to integer
//       const empId = parseInt(employeeId);
      
//       // Build URL with query parameters - exactly matching API specification
//       const url = `${API_BASE_URL}/LineSummary/generate?serverId=${serverId}&area=${area}&shift=${shift}&productionDate=${productionDate}&employeeId=${empId}`;
      
//       console.log('Generate Summary Request URL:', url);
//       console.log('Parameters:', { serverId, area, shift, productionDate, employeeId: empId });

//       const response = await fetch(url, {
//         method: 'POST',
//         headers: {
//           'accept': '*/*'
//         },
//         body: ''
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error('Generate Summary Error Response:', errorText);
//         throw new Error(`Failed to generate summary: ${response.status}`);
//       }

//       const data = await response.json();
//       console.log('Generate Summary Response:', data);
      
//       return {
//         success: true,
//         message: data.message || 'Summary generated successfully',
//         linesProcessed: data.linesProcessed || 0,
//         date: data.date,
//         shift: data.shift
//       };
//     } catch (error) {
//       console.error('Generate Summary API Error:', error);
//       return {
//         success: false,
//         message: error.message || 'An error occurred while generating summary'
//       };
//     }
//   },

//   /**
//    * Get Daily Line Summary
//    * GET /api/LineSummary
//    */
//   getLineSummary: async ({ serverId, area, shift, productionDate }) => {
//     try {
//       const url = `${API_BASE_URL}/LineSummary?serverId=${serverId}&area=${encodeURIComponent(area)}&shift=${shift}&productionDate=${productionDate}`;
      
//       console.log('Get Summary Request URL:', url);

//       const response = await fetch(url, {
//         method: 'GET',
//         headers: {
//           'accept': '*/*'
//         }
//       });

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error('Get Summary Error Response:', errorText);
//         throw new Error(`Failed to fetch summary: ${response.status}`);
//       }

//       const data = await response.json();
//       console.log('Get Summary Response:', data);
      
//       // Handle different response structures
//       let summaryData = [];
//       if (Array.isArray(data)) {
//         summaryData = data;
//       } else if (data.result && Array.isArray(data.result)) {
//         summaryData = data.result;
//       } else if (data.data && Array.isArray(data.data)) {
//         summaryData = data.data;
//       }

//       return {
//         success: true,
//         data: summaryData,
//         message: summaryData.length > 0 ? 'Data loaded successfully' : 'No data found'
//       };
//     } catch (error) {
//       console.error('Get Summary API Error:', error);
//       return {
//         success: false,
//         data: [],
//         message: error.message || 'An error occurred while fetching summary'
//       };
//     }
//   },

//   ///New Changes
//   getLoginHistory: async (filters = {}) => {
//   try {
//     const params = new URLSearchParams();
//     if (filters.startDate) params.append('startDate', filters.startDate);
//     if (filters.endDate)   params.append('endDate',   filters.endDate);

//     const url = `${API_BASE_URL}/LoginHistory?${params.toString()}`;
//     const response = await fetch(url, {
//       method: 'GET',
//       headers: { 'accept': '*/*' }
//     });
//     const data = await response.json();
//     return { success: true, data };
//   } catch (error) {
//     return { success: false, data: [], message: error.message };
//   }
// },

//   /**
//    * Get Target Details for a specific line
//    * GET /api/EntryFrom/savedproductiondetails/range
//    */
//   getTargetDetails: async ({ serverId, shift, area, projCode, lineNo, startDate, endDate }) => {
//     try {
//       const url = `${API_BASE_URL}/EntryFrom/savedproductiondetails/range?serverId=${serverId}&shift=${shift}&area=${area}&projCode=${encodeURIComponent(projCode)}&lineNo=${lineNo}&startDate=${startDate}&endDate=${endDate}`;
      
//       console.log('Get Target Details Request URL:', url);

//       const response = await fetch(url, {
//         method: 'GET',
//         headers: {
//           'accept': '*/*'
//         }
//       });

//       if (!response.ok) {
//         console.warn('Target details not found for:', { projCode, lineNo, shift });
//         return {
//           success: false,
//           data: null
//         };
//       }

//       const data = await response.json();
//       console.log('Get Target Details Response:', data);
      
//       // Get the first item if array
//       const targetData = Array.isArray(data) && data.length > 0 ? data[0] : null;

//       return {
//         success: true,
//         data: targetData
//       };
//     } catch (error) {
//       console.error('Get Target Details API Error:', error);
//       return {
//         success: false,
//         data: null
//       };
//     }
//   }
// };

// export { apiService };
// export default apiService;